import { DownOutlined } from '@ant-design/icons';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ActionKind, ActionParams, BaseClickable } from 'components/ui';
import { TableFactoryRowModel } from 'stores/common';
import { RowActions } from 'stores/common/table/TableFactoryRowModel/config';

import s from './ExpandIcon.module.scss';

type ExpandIconProps = {
  rowEntity?: TableFactoryRowModel;
};

/** Компонент иконки для контроллера Navigation*/
const ExpandIcon: React.FC<ExpandIconProps> = ({ rowEntity }) => {
  const isOpened = rowEntity?.expandedState.opened;

  const handleCollapse = React.useCallback(() => {
    if (!rowEntity?.entity) {
      return;
    }

    rowEntity?.handleCallback({
      kind: RowActions.COLLAPSE_ROW,
      payload: {
        rowId: rowEntity.entity.rowId,
      },
    });
  }, [rowEntity]);

  const handleExpandRows = React.useCallback(() => {
    if (!rowEntity?.entity) {
      return;
    }

    rowEntity?.handleCallback({
      kind: RowActions.FETCH_MORE_ROWS,
      payload: {
        rowId: rowEntity.entity.rowId,
      },
    });
  }, [rowEntity]);

  const clickableAction = React.useMemo((): ActionParams => {
    return {
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick: async (e) => {
          e.stopPropagation();
          e.preventDefault();

          if (!isOpened) {
            handleExpandRows();

            return;
          }

          handleCollapse();
        },
      },
    };
  }, [handleExpandRows, handleCollapse, isOpened]);

  return (
    <BaseClickable withHover withCursorPointer action={clickableAction}>
      <DownOutlined
        className={cn(
          s.navigationController__icons,
          s.navigationController__expandIcon,
          isOpened && s.navigationController__expandIcon_expanded
        )}
      />
    </BaseClickable>
  );
};

export default observer(ExpandIcon);
